<template>
  <v-app>
    <v-main class="backgroundColor" style="padding-left:10%; padding-right: 5%;">
      <router-view name="navigation"  />
      <v-container fluid>
        <router-view />
      </v-container>
    </v-main>
  </v-app>
</template>

<script lang="js">
import Vue from "vue";

export default Vue.extend({
  name: "App",
  // computed: {
  //   permisoMarketing() {
  //     return this.$roles.includes('MARKETING');
  //   },
  //   permisoComercial() {
  //     return this.$roles.includes('COMERCIAL');
  //   },
  //   permisoAdministrador() {
  //     return this.$roles.includes('ADMINISTRADOR');
  //   },
  //   permisoDirectorRegional() {
  //     return this.$roles.includes('DIRECTOR_REGIONAL');
  //   },
  //   permisoDirectorRegional() {
  //     return this.$roles.includes('DIRECTOR_GENERAL');
  //   },
  // },
});
</script>

<style>
.v-window.theme--light {
  background-color: transparent !important;
}
</style>
